import { api, setAccessToken } from "./api";
import type { TokenResponse } from "@/types";

export async function login(email: string, password: string): Promise<void> {
  const data = await api.post<TokenResponse>("/api/auth/login", { email, password });
  setAccessToken(data.access_token);
}

export async function register(
  email: string,
  username: string,
  password: string
): Promise<{ message: string }> {
  return api.post("/api/auth/register", { email, username, password });
}

export async function requestMagicLink(email: string): Promise<{ message: string }> {
  return api.post("/api/auth/magic-link", { email });
}

export async function verifyMagicLink(token: string): Promise<void> {
  const data = await api.get<TokenResponse>(`/api/auth/magic-link/verify?token=${encodeURIComponent(token)}`);
  setAccessToken(data.access_token);
}

export async function verifyEmail(token: string): Promise<{ message: string }> {
  return api.get(`/api/auth/verify-email?token=${encodeURIComponent(token)}`);
}

export function loginWithGoogle(): void {
  window.location.href = "/api/auth/google";
}

export async function logout(): Promise<void> {
  try {
    await api.post("/api/auth/logout");
  } finally {
    setAccessToken(null);
  }
}

export async function refreshToken(): Promise<boolean> {
  try {
    const data = await api.post<TokenResponse>("/api/auth/refresh");
    setAccessToken(data.access_token);
    return true;
  } catch {
    return false;
  }
}
